export default {
  SET_ROOM_DISTRIBUTION(state, payload) {
    state.roomDistribution = payload;
  },
  SET_ROOM_DISTRIBUTION_PAYLOAD(state, payload) {
    state.roomDistributionPayload = payload;
  },
};
